"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { TOKEN_UI_ENABLED } from "@/lib/shared/featureFlags";
import useHasOpened from "@/hooks/useHasOpened";
import { useUiStore } from "@/stores/uiStore";
import PriceMonitorAuthResume from "./PriceMonitorAuthResume";

// Keep the overlays behind idiomatic Next.js client-only boundaries. On
// non-home routes they stay mounted so opening them can use their normal
// entering transition instead of mounting an already-open panel.
const ItemSlideIn = dynamic(() => import("@/components/ItemSlideIn"), { ssr: false });
const FavoritesSlideIn = dynamic(() => import("@/components/FavoritesSlideIn"), { ssr: false });
const PriceMonitorSlideIn = dynamic(() => import("@/components/PriceMonitorSlideIn"), {
  ssr: false,
});
const KurboNoTokensModal = dynamic(() => import("@/components/KurboNoTokensModal"), {
  ssr: false,
});
const AdminItemSlideout = dynamic(() => import("@/components/AdminItemSlideout"), {
  ssr: false,
});
const WarningExplanationModal = dynamic(() => import("@/components/WarningExplanationModal"), {
  ssr: false,
});

export default function GlobalSlideIns() {
  const pathname = usePathname();
  const favoritesModalOpen = useUiStore((state) => state.favoritesModalOpen);
  const priceMonitorOpen = useUiStore((state) => state.priceMonitorOpen);
  const kurboNoTokensNagOpen = useUiStore((state) => state.kurboNoTokensNagOpen);
  const warningModalOpen = useUiStore((state) => state.warningModalOpen);
  const hasOpenedFavorites = useHasOpened(favoritesModalOpen);
  const hasOpenedPriceMonitor = useHasOpened(priceMonitorOpen);
  const hasOpenedKurboNoTokensNag = useHasOpened(kurboNoTokensNagOpen);
  const hasOpenedWarning = useHasOpened(warningModalOpen);

  if (pathname === "/") {
    return (
      <>
        <PriceMonitorAuthResume />
        {hasOpenedFavorites && <FavoritesSlideIn />}
        {hasOpenedPriceMonitor && <PriceMonitorSlideIn />}
        {TOKEN_UI_ENABLED && hasOpenedKurboNoTokensNag && <KurboNoTokensModal />}
        {hasOpenedWarning && <WarningExplanationModal />}
      </>
    );
  }

  return (
    <>
      <PriceMonitorAuthResume />
      <ItemSlideIn />
      <FavoritesSlideIn />
      <PriceMonitorSlideIn />
      {TOKEN_UI_ENABLED && <KurboNoTokensModal />}
      <AdminItemSlideout />
      <WarningExplanationModal />
    </>
  );
}
